import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, Switch } from '../../Components/Form';
import { useSession } from '../../Components/Session';
import API from '../../Services/API';
import { useToasts } from '../../Components/Toasts';

const CommunicationPreferences = () => {
    const {user, refresh} = useSession();
    const {showSuccess, showError} = useToasts();

    const savePreferences = async (data) => {
        return API.post('/users/communicationPreferences', data)
            .then(() => showSuccess('Preferences saved'))
            .then(() => refresh())
            .catch((err) => showError(API.parseErrorResponse(err)));
    }

    return <>
        <TopBar left="BackBtn" title="Communication Preferences" />

        <Page>

            <div className="prose my-4 text-muted text-balance">
                <p>
                    Choose which communications you would like to receive from getSoapy.<br />
                    To choose how you receive notifications related to your account, visit the notifications page.
                </p>
            </div>

            <Form data={user.communicationPreferences} onSubmit={savePreferences} waitForData>
                <Switch
                    name="gettingStarted"
                    label="Getting started emails"
                />
                <Switch
                    name="productUpdates"
                    label="Product updates"
                />
                <Switch
                    name="offersAndPromotions"
                    label="Offers and promotions"
                />
                <Switch
                    name="importantServiceUpdates"
                    label="Important service updates"
                    help={"While you're account is open there's some important information we need to send you."}
                    disabled
                />
                <Actions submit={{label: 'Save'}} />
            </Form>
        </Page>
    </>
}

export default CommunicationPreferences;